module.exports = __webpack_public_path__ + "img/IMG_3869.6b864578.jpg";